{
  "cycle.entite.plans_cadence": "Proposed and applied cadence plans",
  "cycle.entite.sprint_review_actions": "Cadence review actions",
  "journalAudit.action.dependency.declared": "Cross-project dependency declared",
  "journalAudit.action.sprint.plan_applied": "Cadence plan applied",
  "journalAudit.action.sprint.plan_proposed": "Cadence plan proposed"
}
